import { BaseButton } from './base-button';

export class AddButton extends BaseButton {
  constructor() {
    super();
  }

  attached() { }
}
